// @flow
import * as React from "react";
import Space from "ui/atoms/Space";

import { SidePanel } from "@/ui/atoms/SidePanel";

type Props = {
  children: React.Node,
};

function BuilderSideMenu({ children }: Props): React.Node {
  return (
    <SidePanel withBottomPadding>
      <div className="p-4">
        <Space>{children}</Space>
      </div>
    </SidePanel>
  );
}

export default BuilderSideMenu;
